import React from 'react';
import { useTranslation } from 'react-i18next';
import styled from 'styled-components';
import { getTheme } from '../../constants/theme';

const Statistics = styled.dl`
  &&& {
    display: grid;
    grid-template-columns: repeat(3, minmax(0, 1fr));
    margin: 0 0 24px;
    padding: 20px 0;
    border: 1px solid
      ${({ theme }) =>
        (theme.navigation || getTheme('bright').navigation).border};
    border-radius: 12px;
    background: ${({ theme }) =>
      (theme.navigation || getTheme('bright').navigation).surface};
    box-shadow: none;
  }
  .reader-statistic {
    min-width: 0;
    padding: 0 24px;
  }
  .reader-statistic + .reader-statistic {
    border-left: 1px solid
      ${({ theme }) =>
        (theme.navigation || getTheme('bright').navigation).border};
  }
  dt {
    color: ${({ theme }) =>
      (theme.navigation || getTheme('bright').navigation).text};
    font-size: 14px;
    line-height: 1.4;
  }
  dd {
    margin: 8px 0 0;
    font-size: clamp(24px, 4vw, 36px);
    font-weight: 600;
    line-height: 1.1;
    overflow-wrap: anywhere;
    font-variant-numeric: tabular-nums;
    color: ${({ theme }) =>
      (theme.navigation || getTheme('bright').navigation).accent};
  }
  @media (max-width: 767px) {
    &&& {
      margin-bottom: 20px;
      padding: 16px 0;
    }
    .reader-statistic {
      padding: 0 12px;
    }
    dt {
      min-height: 2.8em;
      font-size: 12px;
    }
  }
`;

type Props = { readerStatistics?: any };
const ActiveReaders: React.FC<Props> = ({ readerStatistics }) => {
  const { t } = useTranslation();
  const metrics = [
    ['CurrentlyReading', readerStatistics?.currentlyReading],
    ['WeeklyReaders', readerStatistics?.totalReadersLastWeek],
    ['TotalReaders', readerStatistics?.totalReaders],
  ];
  return (
    <Statistics>
      {metrics.map(([label, value]) => (
        <div className="reader-statistic" key={label}>
          <dt>{t(label)}</dt>
          <dd>{value || 0}</dd>
        </div>
      ))}
    </Statistics>
  );
};
export default ActiveReaders;
